import { FilingTypeEnum } from "../../utils/enums";

const toMap = function (string = "") {
    return new Map(string.split(",").map((box) => [box.trim(), null]));
};
const VAT_RETURNS_SENSITIVE_FIELDS = toMap(
    "Box11,Box1,Box4,Box5,Box6,Box7,Box8,Box9,Box10,Box27,Box29,Box_3100,Box_3200,Box12,Box_D91"
);

export const isSensitive = function (fieldName, filingTypeId) {
    fieldName = typeof fieldName === "string" ? fieldName.trim() : "";
    let isSensitiveField;
    switch (filingTypeId) {
        case FilingTypeEnum.VATRETURN:
            isSensitiveField = VAT_RETURNS_SENSITIVE_FIELDS.has(fieldName);
            break;
        case FilingTypeEnum.LOCALLISTING:
        case FilingTypeEnum.ECLISTING:
        case FilingTypeEnum.INTRASTAT:
        case FilingTypeEnum.INTRASTAT_IN:
        case FilingTypeEnum.INTRASTAT_OUT:
        case FilingTypeEnum.REVERSECHARGELISTING:
        case FilingTypeEnum.VATBOOKS:
            isSensitiveField = true;
            break;
        default:
            isSensitiveField = false;
    }
    return isSensitiveField;
};

const helper = {};
helper.isSensitive = isSensitive;
export default helper;
